import type { Stories, StorySlide } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft } from 'merge-left-utils'

export interface StoriesFormState {
  id?: GQL_ID
  preview_id?: GQL_ID
  name?: string
  status?: number
  sort_order?: number
  preview?: {
    url?: string
  }
  created_at?: Date
  updated_at?: Date
  slides: StorySlide[]
  activeFrom?: Date
  activeUntil?: Date
}

export const STORIES_DEFAULT_STATE: StoriesFormState = {
  id: undefined,
  preview_id: undefined,
  name: '',
  status: 0,
  sort_order: 0,
  preview: { url: undefined },
  created_at: undefined,
  updated_at: undefined,
  slides: [],
  activeFrom: undefined,
  activeUntil: undefined
}

export const makeStoriesFormState = (Stories?: Stories): StoriesFormState => {
  return mergeLeft<StoriesFormState>(STORIES_DEFAULT_STATE, Stories)
}

export const mapStateToApiVariable = (state: StoriesFormState): any => ({
  id: state.id,
  preview_id: state.preview_id,
  name: state.name,
  status: state.status,
  sort_order: Number(state.sort_order),
  slides: state.slides.map((slide) => ({
    image_id: slide.image_id,
    id: slide.id,
    name: slide.name,
    status: slide.status,
    url: slide.url,
    sort_order: Number(slide.sort_order),
    optionOpenInBrowser: slide.optionOpenInBrowser,
    optionOpenInNewWindow: slide.optionOpenInNewWindow
  })),
  activeFrom: state.activeFrom ? state.activeFrom.getTime() : null,
  activeUntil: state.activeUntil ? state.activeUntil?.getTime() : null
})

export const mapApiDataToState = (data: Stories): StoriesFormState => ({
  id: data.id,
  preview_id: data.preview_id,
  name: data.name,
  status: Number(data.status),
  sort_order: Number(data.sort_order),
  preview: data.preview,
  created_at: data.created_at,
  updated_at: data.updated_at,
  slides: data.slides,
  activeFrom: data.activeFrom ? new Date(data.activeFrom as Date) : undefined,
  activeUntil: data.activeUntil ? new Date(data.activeUntil as Date) : undefined
})
